import {useTranslation} from "react-i18next";
import classNames from "classnames";
import BuyTicketButton from "./Buttons/BuyTicketButton";

export default function EventPrice(
    {
        paymentRequired,
        isFinished,
        prices,
        tickets,
        userTicket
    }
) {
    const { t } = useTranslation();
    const isFree = !paymentRequired && !isFinished;
    const showPrice = paymentRequired && !isFinished && !!prices.length;
    const showBuyTicketButton = showPrice && !!tickets.length && !userTicket;
    const canDownloadTicket = userTicket && !isFinished;
    const canDownloadCertificate = userTicket && isFinished;

    return (
        <span
            className={
                classNames(
                    'conference-status',
                    {
                        'free': !paymentRequired && !isFinished,
                        'finished': isFinished,
                    }
                )
            }
        >
            { isFree && t('conferences.free') }
            { isFinished && t('conferences.finished') }
            { showPrice && <>{prices[0].amount}<icon className={`icon-${prices[0].currency.code}-page`} /></> }
            { showBuyTicketButton && <BuyTicketButton tickets={tickets} />
            }
            { canDownloadTicket &&
                <div>
                    <a href={`/my-tickets/${userTicket.id}`} className="btn-conference-page wide btn-primary">{ t('conferences.downloadTicket') }</a>
                </div>
            }
            { canDownloadCertificate &&
                <div>
                    <a href={`/my-tickets/${userTicket.id}/certificate`} className="btn-conference-page wide btn-primary">{ t('conferences.downloadCertificate') }</a>
                </div>
            }
        </span>
    );
}
